import React from "react"
import { css } from "@emotion/core"
import Layout from "../components/Layout"
import JobForm from "../components/JobForm"
import { Arrow, SocialGrid, GradientLinkButton } from "../components/common"

import CareerImage from "../images/career/career.jpg"

const CareerPage = () => (
  <Layout>
    <div
      css={theme => css`
        margin: ${theme.constants.pageMargin};

        @media (max-width: 1200px) {
          margin: ${theme.constants.mediumpageMargin};
        }

        @media (max-width: 1000px) {
          margin: ${theme.constants.smallpageMargin};
        }
      `}
    >
      <>
        <h1
          css={theme => css`
            font-size: ${theme.constants.largeFontSize}px;
            font-weight: ${theme.constants.demi};
            margin-bottom: 50px;
            position: relative;

            @media (max-width: 880px) {
              font-size: ${theme.constants.mediumFontSize}px;
            }
          `}
        >
          Career
        </h1>
        <p
          css={theme => css`
            font-size: ${theme.constants.mediumFontSize}px;
            font-weight: ${theme.constants.extraLight};
            margin-bottom: 100px;
            width: 42%;

            @media (max-width: 1200px) {
              width: 100%;
            }

            @media (max-width: 880px) {
              font-size: ${theme.constants.smallFontSize}px;
              margin-bottom: 50px;
            }
          `}
        >
          We want to meet the makers, the future-facing hustlers with real
          talent.
        </p>
        <div
          css={css`
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(42%, 1fr));
            grid-column-gap: 80px;
            margin-bottom: 100px;

            line-height: 1.7;

            @media (max-width: 880px) {
              grid-template-columns: 1fr;
              margin-bottom: 20px;
            }
          `}
        >
          <div
            css={theme => css`
              font-size: ${theme.constants.smallFontSize}px;
              font-weight: ${theme.constants.extraLight};

              @media (max-width: 880px) {
                font-size: ${theme.constants.infoDescriptionTextSize}px;
                margin-bottom: 30px;
              }
            `}
          >
            We’re always on the lookout for developers who can build and
            innovate the digital future with us - creating the very best IT
            products.
          </div>
          <div
            css={theme => css`
              font-size: ${theme.constants.smallFontSize}px;
              font-weight: ${theme.constants.extraLight};

              @media (max-width: 880px) {
                font-size: ${theme.constants.infoDescriptionTextSize}px;
              }
            `}
          >
            So, are you fresh minded? Creative? Always thinking up new ideas?
            Love to learn? Do you want to develop the best apps and websites
            with us? Send us your CV!
          </div>
        </div>
      </>

      <Arrow top={430} right={50} />
    </div>
    <div
      css={theme => css`
        margin: ${theme.constants.pageMargin};

        @media (max-width: 1200px) {
          margin: ${theme.constants.mediumpageMargin};
        }

        @media (max-width: 1000px) {
          margin: ${theme.constants.smallpageMargin};
        }
      `}
    >
      <p
        css={theme => css`
          font-size: ${theme.constants.mediumFontSize}px;
          font-weight: ${theme.constants.extraLight};
          margin-bottom: 40px;
          width: 42%;

          @media (max-width: 1200px) {
            width: 100%;
          }

          @media (max-width: 880px) {
            font-size: ${theme.constants.smallFontSize}px;
            margin-bottom: 20px;
          }
        `}
      >
        Current positions
      </p>
      <GradientLinkButton
        css={css`
          width: 300px;
          margin-bottom: 50px;
        `}
        to="/fullstack-developer"
      >
        fullstack developer
      </GradientLinkButton>
    </div>
    <div
      css={theme => css`
        background: url(${CareerImage});
        background-size: 100% 80%;
        background-position-x: center;
        background-position-y: top;
        background-repeat: no-repeat;

        color: ${theme.colors.white};

        display: flex;
        flex-direction: column;
        align-items: center;

        @media (max-width: 1200px) {
          background-size: 150%;
        }
        @media (max-width: 880px) {
          position: relative;
          padding: 20px 0;
        }

        @media (max-width: 600px) {
          padding: 50px 0;
          background-size: cover;
          padding-bottom: 0;
        }
      `}
    >
      <div
        css={theme => css`
          font-size: ${theme.constants.largerFontSize}px;
          font-weight: ${theme.constants.demi};

          margin-top: 210px;
          margin-bottom: 30px;
          text-align: center;

          @media (max-width: 880px) {
            margin-top: 50px;
          }
        `}
      >
        We would love to hear from you
      </div>
      <div
        css={theme => css`
          font-size: ${theme.constants.smallFontSize}px;
          font-weight: ${theme.constants.extraLight};
          text-align: center;

          margin-bottom: 140px;

          @media (max-width: 880px) {
            margin-bottom: 50px;
          }
        `}
      >
        We want you to feel at home in the office, to be confident and creative.
        <br />
        Most of all, we are open to your ideas, let that be about a feature or
        our workflow.
      </div>
      <div
        css={theme => css`
          background: ${theme.colors.white};
          box-shadow: ${theme.constants.boxShadow};

          color: ${theme.colors.black};
          width: 65%;

          @media (max-width: 1200px) {
            width: 80%;
          }

          @media (max-width: 880px) {
            width: 100%;
          }
        `}
      >
        <JobForm />
      </div>
    </div>
    <SocialGrid />
  </Layout>
)

export default CareerPage
